export const transformRequestSplitParcel = ({
  selectedItemsIds,
  locationForNewShipment,
  carrierServiceForNewShipment,
}) => {
  const payload = {
    line_item_ids: selectedItemsIds,
    new_shipment_location_id: locationForNewShipment,
    new_shipment_carrier_service_id: carrierServiceForNewShipment,
  }

  return payload
}
